<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

        <material-card

          :title="$t('projects.create.title')"
          :text="$t('projects.create.text')"

        >

          <v-form @submit.prevent="createProject">
            <v-container >
              <v-row>


                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="projectName"
                     :label="$t('project.name')"
                    :error-messages="projectNameErrors"
                    @input="$v.projectName.$touch()"
                    @blur="$v.projectName.$touch()"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="projectNumber"
                    :label="$t('project.projectNumber')"

                  />
                </v-col>



                <v-col cols="12" md="6">
                  <v-combobox
                    v-model="projectType"
                    :items="projectTypes"
                    :item-text="'name'"
                    :item-value="'id'"
                    :label="$t('projects.create.selectProjectType')"
                  ></v-combobox>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    clearable
                    v-model="projectLanguage"
                    :items="languages"
                    :item-text="'language'"
                    :item-value="'locale'"
                    :label="$t('project.language')"
                  ></v-select>
                </v-col>



                <v-col v-if="currentUserDepartmentName==''" cols="12" md="6">
                  <v-select
                    clearable
                    v-model="department"
                    :items="departments"
                    :item-text="'name'"
                    :item-value="'id'"
                    :label="$t('projects.create.selectDepartment')"
                  ></v-select>
                </v-col>




                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn @click.prevent="historyBack">
                    {{$t("global.cancel")}}
                  </v-btn>&nbsp;
                  <v-btn  @click="submit" color="success">
                    {{$t("global.save")}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>

    </v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
import languageUtil from '../utils/language'
    import { required, maxLength} from 'vuelidate/lib/validators'

    export default {
        data() {
            return {
                projectType:"",
                projectName: "",
                projectNumber:"",
                department :"",
                departments : [],
                projectTypes: [],
                languages:[],
                projectLanguage:"",
                templateProjectId:""
            }
        },
        validations: {
            projectName: {
                required,
                maxLength:maxLength(255)
            }
        },
        methods: {
            submit () {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.createProject()
                }
            },
            getProject(projectid) {
                api.getProject(projectid).then(response => {
                    this.projectName= response.name + ' - ' +this.$i18n.t('projects.create.copy')
                    this.projectNumber = response.projectNumber
                    this.projectLanguage = response.language
                    this.projectType = response.projectType
                    this.department = response.department
                    this.templateProjectId = response.id

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },

            createProject() {
                api.createProject(this.projectName, this.projectNumber, this.projectType, this.projectLanguage, this.department, this.templateProjectId).then(response => {
                    this.$router.push({path: '/projectShow/' + response.id});
                    //   console.log(response.data)
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })


            },
            getProjectTypes() {
                api.getProjectTypes().then(response => {
                    this.projectTypes = response
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
          getDepartments() {
            api.getDepartments().then(response => {
              this.departments = response
            })
              .catch(error => {
                this.$store.commit('setErrorMsg', error)
                console.log(error)
                //    this.errors.push(error)
              })
          },
            getLanguages() {
                languageUtil.getProjectLanguages().then(response => {
                    this.languages = response
                })
                    .catch(error => {
                         this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            }
        },
        computed: {
            projectNameErrors () {
                const errors = []
                if (!this.$v.projectName.$dirty) return errors
                !this.$v.projectName.maxLength && errors.push(this.$t('validation.maxLength', [this.$t('project.name'), 255]))
                !this.$v.projectName.required && errors.push(this.$t('validation.required', [this.$t('project.name')]))
                return errors
            }
        },
        mounted() {
            this.getProjectTypes()
            this.getLanguages()
          this.getDepartments()
            if (this.$route.params.templateProjectId !=undefined) {
                this.templateProjectId = this.$route.params.templateProjectId
                this.getProject(this.$route.params.templateProjectId)
            }
        }
    }
</script>
